import React, { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { connect } from "react-redux";
import Stack from "@mui/material/Stack";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Radio, Paper } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import { useSelector } from "react-redux";
import GraphService from "../../../../services/console_services/Graph";
import Loading from "../../Loading";
import ChartsForIF from "./ChartsForIF";
import TableWithChart from "../LT_Capacity_Breach";
import CustomScrollButton from "../../ReusableComponents/CustomTabScrollButton";

// const N_POOS_RISK_DATA = [
//     {
//         "Network": "2-DEC",
//         "N_POOS_Risk": 200

//     },
//     {
//         "Network": "3-DEC",
//         "N_POOS_Risk": 300

//     },
//     {
//         "Network": "4-DEC",
//         "N_POOS_Risk": 100

//     },
//     {
//         "Network": "5-DEC",
//         "N_POOS_Risk": 250

//     },
//     {
//         "Network": "6-DEC",
//         "N_POOS_Risk": 100

//     },
//     {
//         "Network": "7-DEC",
//         "N_POOS_Risk": 250

//     }
// ];

// const R_POOS_RISK_DATA = [
//     {
//         "Network": "2-DEC",
//         "R_POOS_Risk": 10

//     },
//     {
//         "Network": "3-DEC",
//         "R_POOS_Risk": 30

//     },
//     {
//         "Network": "4-DEC",
//         "R_POOS_Risk": 40

//     },
//     {
//         "Network": "5-DEC",
//         "R_POOS_Risk": 70

//     },
//     {
//         "Network": "6-DEC",
//         "R_POOS_Risk": 80

//     },
//     {
//         "Network": "7-DEC",
//         "R_POOS_Risk": 20

//     }
// ];

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={1}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((_theme) => ({
  root: {
    flexGrow: 1,
    dispatch: "flex",
    padding: "10px",
  },
  paper: {
    boxShadow: "none !important",
  },
  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "58vh",
    width: "100%",
    position: "relative",
    top: 0,
    left: 0,
  },
  select: {
    borderColor: "transparent",
    borderStyle: "none",
    height: "30px",
    width: "120px",
    borderRadius: "4px !important",
    background: "var(--Neutral-Colors-White, #FFF)",
    fontSize: "14px !important",
    color: "#404041 !important",
    "&.MuiOutlinedInput-root": {
      margin: "0px 17px",
    },
  },
  main: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    padding: "0px 10px",
  },
  appBar: {
    padding: "10px",
  },
  tab: {
    background: "#FFF",
    boxShadow:
      "0px 2px 4px 0px rgba(0, 0, 0, 0.10), 0px 4px 12px 0px rgba(0, 0, 0, 0.10)",
    flex: 1,
    minHeight: "30px",
    borderRadius: "8px",
  },
  activeTabs: {
    color: "#FFF",
    textAlign: "center",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    fontWeight: "500",
    textTransform: "none",
    borderRight: "1px solid #92949747",
    minHeight: "30px",
    border: "1px solid var(--Neutral-Colors-Off-White, #E6E7E8)",
    background: "var(--Nestle_Blue, #0067A1)",
  },
  inActiveTabs: {
    color: "#59595A",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    textTransform: "none",
    minHeight: "30px",
    opacity: 1,
    border: "1px solid var(--Neutral-Colors-Off-White, #E6E7E8)",
    background: "var(--Neutral-Colors-White, #FFF)",
  },
  indicator: {
    display: "none",
  },
  filter: {
    fontSize: "14px",
    margin: "0px 2px",
  },
  dropDownLabel: {
    marginTop: "2px",
  },
}));

const networkOptions = [
  { entity: "Network", value: "AMBIENT" },
  { entity: "Network", value: "CHILLED" },
  { entity: "Network", value: "FROZEN" },
  { entity: "Network", value: "NPW" },
];

const GraphViewIF_Overall = ({
  tabIndex,
  Module,
  Network,
  DC,
  Products,
  Division,
  PL3,
  graphViewTabList,
  date,
  applyFilter,
  role,
  moduleTabIndexChange,
}) => {
  const classes = useStyles();
  const { instance } = useMsal();
  // const [unitValue, setUniteValue] = useState("Dollars");
  const unitValue = "Dollars";
  const tabValue = useSelector((state) => state?.tabs?.moduleTabIndex);
  const [graphData, setGraphData] = useState([]);
  const [graphDataLT, setGraphDataLT] = useState([]);
  const [expansionGraphDataLT, setExpansionGraphDataLT] = useState([]);
  const [showGraph, setShowGraph] = useState(false);
  const [entityAndThreshold, setEntityAndThreshold] = useState([]);
  const [updateThreshold, setUpdateThreshold] = useState(false);
  const [entityNameLT, setEntityNameLT] = useState("");
  const [currentRowIndex, setCurrentRowIndex] = useState(null);
  const [loading, setLoading] = useState(true);
  const activeTab = graphViewTabList?.filter(
    (item) => item?.index === tabValue
  )[0]?.name;
  // const activeFlagValue = useSelector((state) => state?.filter?.activeFlag);
  // const [byWeeksOrMonths, setByWeeksOrMonths] = useState("Weekly");
  // const [topOrBottomValue, setTopOrBottomValue] = useState("Top");
  const topOrBottomValue = "Top";
  // const [countValue, setCountValue] = useState("5");
  const countValue = "5";
  const countList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  // const selectedScenarios = useSelector((state) => state?.filter?.selectedScenarios);
  const [monthValue, setMonthValue] = useState(6);
  const [duration, setDuration] = useState(4);
  // const [metricName, setMetricName] = useState("Network");
  const metricName = "Network";
  // const [metricOptions, setMetricOptions] = useState([...networkOptions]);

  const radioOptions = () => {
    const optionsMap = {
      COF: ["Overall", "Network"],
      Wastage: ["Overall", "Network", "Division"],
      "Cost Savings": ["Overall", "Network"],
      "Delivery Cost": ["Overall", "Network"],
      "Long Term Capacity Breach": [],
    };

    return optionsMap[activeTab] || [];
  };
  const [selectedRadioValue, setSelectedRadioValue] = useState(
    radioOptions()[0]
  );

  // const [value, setValue] = React.useState([networkOptions[0]]);
  const [value] = React.useState([networkOptions[0]]);
  const getGraphData = (params) => {
    setGraphData([]);
    setLoading(true);
    GraphService.getGraph(params, instance)
      .then((data) => {
        if (data?.data) {
          if (activeTab === "Long Term Capacity Breach") {
            if (entityNameLT) {
              setExpansionGraphDataLT([...data?.data]);
            } else {
              setGraphDataLT([...data?.data]);
            }
          } else {
            setGraphData([...data?.data]);
          }
        }
      })
      .catch((error) => console.error("Error:", error))
      .finally(() => {
        setLoading(false);
        setEntityAndThreshold([]);
        setUpdateThreshold(false);
      });
  };

  const memoizedParams = useMemo(() => {
    let params = {
      section: Module,
      type: graphViewTabList[tabValue]?.value,
      name: selectedRadioValue,
      arrangements: topOrBottomValue,
      value: countValue,
      X_Axis: selectedRadioValue,
      Week_count: duration,
      //start_Date: new Date(startDate).toLocaleDateString('en-CA'),
      //start_Date: "2024-12-01",
      //end_Date: new Date(endDate).toLocaleDateString('en-CA'),
      //end_Date: "2025-06-01",
      Level: role,
      filter: {
        RecommendedDC: DC,
        Network: Network,
        startDate: date?.[0],
        endDate: date?.[1],
      },
    };
    if (updateThreshold) {
      params.user_threshold = entityAndThreshold;
    }
    if (entityNameLT) {
      params.flag = true;
      params.Entity_name = entityNameLT;
    }

    return params;
  }, [
    Module,
    tabValue,
    selectedRadioValue,
    topOrBottomValue,
    countValue,
    role,
    DC,
    Network,
    PL3,
    Division,
    Products,
    date,
    duration,
    updateThreshold,
    entityNameLT,
    metricName,
    value,
    monthValue,
  ]);

  useEffect(() => {
    // Conditional check to avoid unnecessary API calls
    if (
      !memoizedParams.section ||
      !memoizedParams.type ||
      !memoizedParams.name ||
      !memoizedParams.filter.startDate ||
      !memoizedParams.filter.endDate
    ) {
      return;
    }
    getGraphData(memoizedParams);
  }, [memoizedParams, applyFilter]);

  const handleChange = (_event, newValue) => {
    moduleTabIndexChange(newValue);
  };

  const handleRadioChange = (selectedFilter) => {
    setSelectedRadioValue(selectedFilter);
  };

  const handleMonthChange = (event) => {
    setMonthValue(event.target.value);
  };

  const handleDurationChange = (event) => {
    setDuration(event.target.value);
  };

  const renderChart = () => {
    if (["COF", "Cost Savings", "Delivery Cost"]?.includes(activeTab)) {
      return (
        <ChartsForIF
          graphData={graphData}
          activeTab={activeTab}
          type={unitValue}
          showAnnotation={
            ["COF", "Delivery Cost"]?.includes(activeTab) ? true : false
          }
        />
      );
    } else if (activeTab === "Long Term Capacity Breach") {
      return (
        <TableWithChart
          activeTab={activeTab}
          graphData={
            entityNameLT ? [graphDataLT[currentRowIndex]] : graphDataLT || []
          }
          expansionGraphData={expansionGraphDataLT}
          showGraph={showGraph}
          setShowGraph={setShowGraph}
          entityAndThreshold={entityAndThreshold}
          setEntityAndThreshold={setEntityAndThreshold}
          updateThreshold={updateThreshold}
          setUpdateThreshold={setUpdateThreshold}
          entityName={entityNameLT}
          setEntityName={setEntityNameLT}
          currentRowIndex={currentRowIndex}
          setCurrentRowIndex={setCurrentRowIndex}
        />
      );
    }
  };

  return (
    <Paper elevation={0} className={classes.paper}>
      {loading ? (
        <div className={classes.loader}>
          <Loading />
        </div>
      ) : (
        <>
          {/* <div className={classes.main}>
                        <div className={classes.appBar}> */}
           <Box
            sx={{
              maxWidth: "70vw",
              overflow: "hidden",
            }}
          >
            <Tabs
              value={tabValue}
              onChange={handleChange}
              className={classes.tab}
              aria-label="simple tabs example"
              variant="scrollable"
              scrollButtons="auto"
              ScrollButtonComponent={CustomScrollButton}
              classes={{ indicator: classes.indicator }}
            >
              {graphViewTabList.map((item, index) => (
                <Tab
                  key={index}
                  className={
                    tabValue === index
                      ? classes.activeTabs
                      : classes.inActiveTabs
                  }
                  label={item.name}
                  style={{
                    minHeight: "35px",
                  }}
                  {...a11yProps(index)}
                />
              ))}
            </Tabs>
          </Box>
          {/* </div>
                    </div> */}
          {graphViewTabList?.map((_item, index) => (
            <TabPanel key={index} value={tabIndex} index={index}>
              <Stack direction="row" spacing={1} alignItems="center">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    {(activeTab === "COF" ||
                      activeTab === "Wastage" ||
                      activeTab === "Cost Savings" ||
                      activeTab === "Delivery Cost") && (
                      <Select
                        value={monthValue}
                        onChange={handleMonthChange}
                        className={classes.select}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        sx={classes.select}
                      >
                        {countList?.map((item, _index) => (
                          <MenuItem key={item} value={item}>
                            {item} Months
                          </MenuItem>
                        ))}
                      </Select>
                    )}

                    {activeTab === "Long Term Capacity Breach" && (
                      <>
                        <span style={{ paddingLeft: "10px" }}>
                          Breach Duration
                        </span>
                        <Select
                          value={duration}
                          onChange={handleDurationChange}
                          className={classes.select}
                          displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                          sx={classes.select}
                        >
                          {countList.map((item, _index) => (
                            <MenuItem key={item} value={item}>
                              {item} Weeks
                            </MenuItem>
                          ))}
                        </Select>
                      </>
                    )}

                    {radioOptions().map((option) => (
                      <React.Fragment key={option}>
                        <Radio
                          value={option}
                          checked={selectedRadioValue === option}
                          onChange={() => handleRadioChange(option)}
                          size="small"
                          inputProps={{ "aria-label": option }}
                          sx={{
                            color: "#359DD0 !important",
                            "&.Mui-checked": {
                              color: "#359DD0 !important",
                            },
                          }}
                        />
                        <span
                          className={classes.filter}
                          style={{
                            color:
                              selectedRadioValue ===
                              (Module === "SNO" ? "Overall" : "Network")
                                ? "#359DD0"
                                : "#359DD0",
                          }}
                        >
                          {option}
                        </span>
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              </Stack>
              {renderChart()}
            </TabPanel>
          ))}
        </>
      )}
    </Paper>
  );
};

GraphViewIF_Overall.propTypes = {
  tabIndex: PropTypes.number.isRequired,
  tabChange: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  tabIndex: state.tabs.index,
  Network: state.filter.Network,
  DC: state.filter.DC,
  Products: state.filter.Products,
  PL3: state.filter.PL3,
  date: state.filter.Date,
  Division: state.filter.Division,
  applyFilter: state.filter.applyFilter,
  role: state.login.role,
});

const mapDispatchToProps = (dispatch) => ({
  tabChange: (newValue) => dispatch({ type: "TAB_INDEX", payload: newValue }),
  moduleTabIndexChange: (newValue) =>
    dispatch({ type: "MODULE_TAB_INDEX", payload: newValue }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GraphViewIF_Overall);
